var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.66176 0.745885C5.98033 -0.163676 7.26665 -0.163673 7.58522 0.745888L8.32066 2.84569C8.46377 3.2543 8.84945 3.52786 9.28239 3.52786H11.4899C12.4954 3.52786 12.8932 4.82985 12.0594 5.39186L10.4083 6.5047C10.0241 6.76367 9.86297 7.24924 10.0161 7.68653L10.6772 9.57408C11.0014 10.4996 9.95916 11.304 9.14597 10.7559L7.19302 9.4396C6.84878 9.20758 6.3982 9.20758 6.05396 9.4396L4.10101 10.7559C3.28783 11.304 2.24559 10.4996 2.56975 9.57408L3.23085 7.68653C3.38401 7.24924 3.22287 6.76367 2.83866 6.50471L1.18759 5.39186C0.353761 4.82985 0.751576 3.52786 1.75712 3.52786H3.96459C4.39754 3.52786 4.78321 3.2543 4.92632 2.84569L5.66176 0.745885Z"}));
}

Star.defaultProps = {"width":"13","height":"11","viewBox":"0 0 13 11","fill":"none"};

module.exports = Star;

Star.default = Star;
